$('.video_modal').each(function(){
    $('[data-vid]').each(function () {
        var vidId = $(this).data('vid');
        window._wq = window._wq || [];
        _wq.push({
          id: vidId,
          options: {
            popover: true,
            popoverDisableAutoPlay: false,
            popoverContent: "html",
            playButton: true,
            playbar: false,
            muted: false,
            controlsVisibleOnLoad: false,
            playSuspendedOffScreen: false,
            popoverPreventScroll: true,
            popoverOverlayColor: "#1e1e1e"
          }
        });
    });
})